import { Button, Col, Form, Row } from 'antd';
import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { MasterStationsWithSearchKeys } from 'domain/entities/MasterEntity';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormInputAutoComplete } from 'presentation/components/form/FormInputAutoComplete.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { InputNumberWithFraction } from '../../CU-031-01/components/Input';

export const EvaluateForm = (props: AppProps) => {
    const [isDiasbleRepairFund, setIsDiasbleRepairFund] = useState<boolean>(true);
    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { masterUseCase, assessmentUseCase } = props;
    const [allStation, setAllStation] = React.useState<OptionEntity[]>([]);
    const [stationSelect, setStationSelect] = React.useState<any>();
    useEffect(() => {
        getStationByKeys('');
    }, []);

    React.useEffect(() => {
        if (isDiasbleRepairFund) {
            form.setFieldsValue({
                repair_fund: undefined,
            });
        }
    }, [isDiasbleRepairFund]);

    const getStationByKeys = async (key: string) => {
        try {
            dispatch(startFetching());
            const response = await masterUseCase.getMasterStationByKeys(key);
            const stationOption = response.result?.map((item: MasterStationsWithSearchKeys) => {
                return {
                    value: item.stationCd,
                    label: item.stationName,
                    code: item.stationCd,
                };
            });
            const stationList = stationOption.filter(function (item, pos, self) {
                return self.indexOf(item) == pos;
            });
            setAllStation(stationList);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then((values) => {
                if (values.age_building || values.rent_price) {
                    setBtnDisable(false);
                } else {
                    setBtnDisable(true);
                }
            })
            .catch((err) => {
                const isValid = err.errorFields.length == 0;
                if (isValid) {
                    const values = err.values;
                    if (values.age_building || values.rent_price) {
                        setBtnDisable(false);
                    } else {
                        setBtnDisable(true);
                    }
                } else {
                    setBtnDisable(true);
                }
            });
    };

    const onSubmitForm = async (values: any) => {
        try {
            dispatch(startFetching());
            const stationName = allStation?.find((val) => val.value === values.station)?.label;
            const assessmentSimple: AssessmentSimple = {
                ...values,
                area: commonHelpers.toNumberOnly(values.area),
                rent_price: commonHelpers.toNumberOnly(values.rent_price),
                repair_fund: commonHelpers.toNumberOnly(values.repair_fund),
                station_cd: stationSelect?.code,
                stationName: stationName,
            };
            const response = await assessmentUseCase.putAssessmentSimpleData(assessmentSimple);
            const data = response.result;
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_03}`, {
                state: {
                    assessmentData: assessmentSimple,
                    range: data,
                    stationSelect: stationSelect,
                },
            });
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div className="form-container">
            <>
                <Form
                    form={form}
                    onValuesChange={onChangeForm}
                    onFinish={onSubmitForm}
                    style={{ width: '100%' }}
                >
                    <Row className="min-w-min">
                        <div className="w-full mb-[48px]">
                            <Row gutter={[0, 12]} className="md-6" style={{ marginBottom: '2%' }}>
                                <Col span={12} className="pr-[12px]">
                                    <span className="content-form heading-form">
                                        物件情報をご入力ください。
                                    </span>
                                </Col>
                            </Row>
                            <Row gutter={[0, 12]} className="md-6">
                                <Col span={12} className="pr-[12px]">
                                    <FormInput
                                        label="築年数"
                                        required
                                        name="age_building"
                                        type="number"
                                        size={'large'}
                                        labelClassName="content-form label-form"
                                        suffix="年"
                                        placeholder={PLACEHOLDER.BUILDING_AGE}
                                        maxLength={2}
                                    />
                                </Col>
                                <Col span={12} className="pl-[12px]">
                                    <InputNumberWithFraction
                                        label="専有面積"
                                        name="area"
                                        isRequired
                                        addonAfter="m²"
                                        labelClassName="content-form label-form"
                                        requiredMessage={getMessage('In_Required', '専有面積')}
                                        max={999.99}
                                        placeholder={PLACEHOLDER.OCCUPIED_AREA}
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[0, 12]} className="md-6">
                                <Col span={12} className="pr-[12px]">
                                    <FormInputAutoComplete
                                        name="station_cd"
                                        label="最寄駅"
                                        required
                                        size={'large'}
                                        allowClear={false}
                                        onSelect={(option) => {
                                            setStationSelect(option);
                                            form.setFieldValue('station_cd', option?.label);
                                        }}
                                        options={allStation ?? []}
                                        notFoundContent={'該当するデータはありません。'}
                                        onBlurEvent={(option) => {
                                            if (option) {
                                                setStationSelect(option);
                                                form.setFieldsValue({ station_cd: option.label });
                                            } else {
                                                setStationSelect(undefined);
                                                form.setFieldsValue({ station_cd: null });
                                                form.validateFields(['station_cd'], { validateOnly: false })
                                                    .then(() => {
                                                        onChangeForm()
                                                    }).catch((err) => {
                                                        if (err.errorFields.length > 0) {
                                                            setBtnDisable(true);
                                                        } else {
                                                            onChangeForm();
                                                        }
                                                    });
                                            }
                                        }}
                                        placeholder={PLACEHOLDER.SELECT}
                                        maxLength={20}
                                        labelClassName="content-form label-form"
                                        currentForm={form}
                                        onValidateError={(isError) => {
                                            if (isError) {
                                                setBtnDisable(true);
                                            } else {
                                                onChangeForm();
                                            }
                                        }}
                                    />
                                </Col>

                                <Col span={12} className="pl-[12px]">
                                    <FormInput
                                        label="徒歩"
                                        name="on_foot_time"
                                        required
                                        placeholder={PLACEHOLDER.ON_FOOT_TIME}
                                        min={0}
                                        max={99}
                                        type="number"
                                        size={'large'}
                                        labelClassName="content-form label-form"
                                        suffix="分"
                                        maxLength={3}
                                        currentForm={form}
                                        onValidateError={(isError) => {
                                            if (isError) {
                                                setBtnDisable(true);
                                            } else {
                                                onChangeForm();
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row
                                gutter={[0, 12]}
                                className="md-6"
                                style={{ margin: '1% 0% 2% 0%' }}
                            >
                                <Col span={12} className="pr-[12px]">
                                    <span
                                        className="content-form heading-form"
                                        style={{ fontWeight: '200', fontSize: '14px' }}
                                    >
                                        以下の情報を入力するとより高い精度で査定可能です。
                                    </span>
                                </Col>
                            </Row>

                            <Row gutter={[0, 12]} className="md-6">
                                <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="家賃・共益費・管理費など（収入）"
                                    name="rent_price"
                                    placeholder={PLACEHOLDER.RENT}
                                    maxLength={6}
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="円"
                                    type="number"
                                    onKeyPress={(event) => {
                                        const charCode = event.charCode;
                                        if (charCode < 48 || charCode > 57) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={(value) => {
                                        setIsDiasbleRepairFund(!value);
                                    }}
                                />
                                </Col>
                                <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="管理費・修繕積立金・その他費用など（支出）"
                                    name="repair_fund"
                                    required={!isDiasbleRepairFund}
                                    disabled={isDiasbleRepairFund}
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="円"
                                    placeholder={PLACEHOLDER.MANAGEMENT_FEE_AND_OTHER_EXPENSES}
                                    maxLength={7}
                                    type="number"
                                    currentForm={form}
                                    onKeyPress={(event) => {
                                        const charCode = event.charCode;
                                        if (charCode < 48 || charCode > 57) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onValidateError={(isError) => {
                                        if (isError) {
                                            setBtnDisable(true);
                                        } else {
                                            onChangeForm();
                                        }
                                    }}
                                />
                                </Col>
                            </Row>
                            
                            <Row justify="center" className="w-full mb-6">
                                <Col span={8}>
                                    <div
                                        className="button-container"
                                        style={{
                                            cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                            background: `${btnDisable ? '#D0D3D8' : '#4bcae5'}`,
                                        }}
                                        onClick={() => (
                                            !btnDisable ? form.submit() : null)
                                        }
                                    >
                                        計算
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>
                </Form>
            </>
        </div>
    );
};
